import { Select } from 'antd';
import {
  Text,
  CaretDownOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
} from 'farmhub-ui-core';

import { theme } from 'styled';
import { filterOption } from 'utils/function';

import { CSelect, Wrapper } from './styles';

const { Option } = Select;
interface OrderTableProps {
  value?: any;
  list: Array<any>;
  height?: string;
  width?: string;
  onChange?: (e: any) => void;
}

const OrderTable = ({
  value,
  list,
  width = '210px',
  height = '36px',
  onChange = () => 0,
}: OrderTableProps): JSX.Element => (
  <Wrapper height={height} width={width}>
    {value && value.value === 1 ? (
      <SortDescendingOutlined
        style={{ color: theme.colors.primary.main, fontSize: 18 }}
        onClick={() =>
          onChange({
            ...value,
            value: 0,
          })
        }
      />
    ) : (
      <SortAscendingOutlined
        style={{ color: 'red', fontSize: 18 }}
        onClick={() =>
          onChange({
            ...value,
            value: 1,
          })
        }
      />
    )}
    <CSelect
      showSearch
      filterOption={(input: string, option: any) => filterOption(input, option)}
      height={height}
      suffixIcon={<CaretDownOutlined />}
      value={value && value.name}
      width={width}
      onChange={e =>
        onChange({
          ...value,
          name: e,
        })
      }
    >
      {list.map(item => (
        <Option key={item.key} value={item.value}>
          <Text lineNumber={1}>{item.name}</Text>
        </Option>
      ))}
    </CSelect>
  </Wrapper>
);

export default OrderTable;
